const parseBoolean = (value: string | undefined) => value === 'true'

export const appEnv = Object.freeze({
  // 生产环境固定走 H5 同域反向代理，避免部署变量误配后再次触发 CORS。
  apiBaseUrl: import.meta.env.PROD
    ? '/api'
    : import.meta.env.VITE_API_BASE_URL || '/api',
  appTitle: import.meta.env.VITE_APP_TITLE || '专属会员服务',
  // 非微信浏览器仅允许在本地开发时绕过，生产包无法通过环境变量开启。
  allowNonWechatAuth:
    import.meta.env.DEV &&
    parseBoolean(import.meta.env.VITE_ALLOW_NON_WECHAT_AUTH),
})
